import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-2xl mb-3" }, "Admin Catalogue", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_filter_table = _resolveComponent("filter-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_list = _resolveComponent("list")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_CatalogFromUrlDialog = _resolveComponent("CatalogFromUrlDialog")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_section_layout_content, _mergeProps(_ctx.content, {
    onActionCreate: _ctx.create,
    onActionExport: _ctx.exportCatalog,
    onActionImport: _ctx.createDropship,
    onActionOtherButton1: _ctx.onCreateByUrl
  }), {
    default: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 24,
            class: "mt-3 flex"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_filter_table, {
                onOnFilterCallback: _ctx.onFilterCallback,
                placeholder: "Search"
              }, null, 8, ["onOnFilterCallback"]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.params.dropship,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.dropship) = $event)),
                clearable: "",
                class: "ml-3",
                placeholder: "Type"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    key: "Dropship",
                    label: "Dropship",
                    value: true
                  }),
                  _createVNode(_component_el_option, {
                    key: "POD",
                    label: "POD",
                    value: false
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.params.isTrademark,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.isTrademark) = $event)),
                clearable: "",
                class: "ml-3",
                placeholder: "Trademark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    key: "Not Trademark",
                    label: "Not Trademark",
                    value: false
                  }),
                  _createVNode(_component_el_option, {
                    key: "Trademark",
                    label: "Trademark",
                    value: true
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.params.publishStatus,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.publishStatus) = $event)),
                clearable: "",
                class: "ml-3",
                placeholder: "Status"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PUBLISH_STATUS_ARR, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, {
                          type: _ctx.getPublishStatusTagColor(item.value)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getPublishStatusName(item.value)), 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]),
                      _: 2
                    }, 1032, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.params.outOfStock,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.outOfStock) = $event)),
                clearable: "",
                class: "ml-3",
                placeholder: "Stock"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    key: "0",
                    label: "Out of stock",
                    value: true
                  }),
                  _createVNode(_component_el_option, {
                    key: "1",
                    label: "In stock",
                    value: false
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_list, {
        documents: _ctx.documents,
        isLoading: _ctx.isLoading,
        onOnAfterUpdate: _ctx.onAfterUpdate
      }, null, 8, ["documents", "isLoading", "onOnAfterUpdate"]), [
        [_directive_loading, _ctx.isLoading]
      ]),
      _createVNode(_component_pagination, {
        total: _ctx.total,
        pagination: _ctx.params.page,
        "onUpdate:pagination": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.page) = $event)),
        limit: _ctx.params.limit,
        "onUpdate:limit": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.params.limit) = $event))
      }, null, 8, ["total", "pagination", "limit"]),
      _createVNode(_component_CatalogFromUrlDialog, {
        ref: "catalogFromUrlDialog",
        onOnAfterCreateCatalog: _ctx.onAfterUpdate
      }, null, 8, ["onOnAfterCreateCatalog"])
    ]),
    _: 1
  }, 16, ["onActionCreate", "onActionExport", "onActionImport", "onActionOtherButton1"])), [
    [_directive_loading, _ctx.isLoading]
  ])
}